import { CommonModule } from "@angular/common";
import { Pipe, PipeTransform, NgModule, Inject } from "@angular/core";

import { LOCALE } from "@hermes/app-core";
import { Locale } from "@hermes/locale";

@Pipe({
    name: "hSpaceSeparator",
})
export class SpaceSeparatorPipe implements PipeTransform {
    constructor(@Inject(LOCALE) private locale: Locale) {}

    public transform(key: string, separator: string, value: string): string {
        return `${key}${
            this.locale.langCode === "fr" ? " " : ""
        }${separator} ${value}`;
    }
}

@NgModule({
    imports: [CommonModule],
    declarations: [SpaceSeparatorPipe],
    providers: [SpaceSeparatorPipe],
    exports: [SpaceSeparatorPipe],
})
export class SpaceSeparatorPipeModule {}
